(() => {
  const alertTranslations = new Map([
    ['Notify me when price goes down', 'Varsle meg når prisen synker'],
    ['Notify me when available', 'Varsle meg når varen er på lager igjen'],
    ['Notify me when back in stock', 'Varsle meg når varen er på lager igjen']
  ]);

  const cleanText = (el) => (el && el.textContent ? el.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim() : '');
  const phrases = Array.from(new Set([...alertTranslations.keys(), ...alertTranslations.values()]));
  const matchesAlert = (text) => phrases.some((phrase) => text.includes(phrase));
  const setImportant = (el, prop, value) => { if (el && el.style) el.style.setProperty(prop, value, 'important'); };

  const ensureProductStyleOverrides = () => {
    if (document.getElementById('lunverk-product-overrides')) return;
    const style = document.createElement('style');
    style.id = 'lunverk-product-overrides';
    style.textContent = '#MainContent[data-template="product"] .product-form{padding-bottom:0!important}#MainContent[data-template="product"] .product-form::after{content:none!important;display:none!important}';
    document.head.appendChild(style);
  };

  const replaceAlertTextNodes = (el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.nodeValue) continue;
      alertTranslations.forEach((replacement, phrase) => {
        if (node.nodeValue.includes(phrase)) node.nodeValue = node.nodeValue.replace(phrase, replacement);
      });
    }
  };

  const flatten = (el) => {
    [['margin','0'],['padding','0'],['background','transparent'],['background-color','transparent'],['border','0'],['border-radius','0'],['box-shadow','none'],['outline','none'],['opacity','1'],['filter','none']].forEach(([p,v]) => setImportant(el,p,v));
  };

  const ensureBellIcon = (wrapper, color) => {
    if (!wrapper) return;

    wrapper.querySelectorAll('svg, img').forEach((node) => {
      if (!node.classList.contains('lunverk-alert-icon')) setImportant(node, 'display', 'none');
    });

    let icon = wrapper.querySelector('.lunverk-alert-icon');
    if (!icon) {
      const ns = 'http://www.w3.org/2000/svg';
      icon = document.createElementNS(ns, 'svg');
      icon.classList.add('lunverk-alert-icon');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');

      const bell = document.createElementNS(ns, 'path');
      bell.setAttribute('d', 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9');
      bell.setAttribute('fill', 'none');
      bell.setAttribute('stroke-linecap', 'round');
      bell.setAttribute('stroke-linejoin', 'round');

      const clapper = document.createElementNS(ns, 'path');
      clapper.setAttribute('d', 'M10 21h4');
      clapper.setAttribute('fill', 'none');
      clapper.setAttribute('stroke-linecap', 'round');

      icon.appendChild(bell);
      icon.appendChild(clapper);
      wrapper.insertBefore(icon, wrapper.firstChild);
    }

    [['display','block'],['flex','0 0 auto'],['width','20px'],['height','20px'],['margin','0'],['color',color],['opacity','1'],['filter','none']].forEach(([p,v]) => setImportant(icon,p,v));
    icon.querySelectorAll('*').forEach((node) => {
      setImportant(node, 'stroke', color);
      setImportant(node, 'stroke-width', '1.8');
      setImportant(node, 'opacity', '1');
    });
  };

  const hideDuplicateTrust = () => {
    if (!document.body) return;
    document.body.querySelectorAll('*').forEach((el) => {
      const text = cleanText(el);
      const isDuplicate = text.length > 0 && text.length < 100 && text.includes('Sendes fra Norge') && text.includes('Ingen toll eller importgebyrer') && !text.includes('Trygg handel');
      if (!isDuplicate) return;
      const childMatches = Array.from(el.children).some((child) => {
        const t = cleanText(child);
        return t.length > 0 && t.length < 100 && t.includes('Sendes fra Norge') && t.includes('Ingen toll eller importgebyrer') && !t.includes('Trygg handel');
      });
      if (!childMatches) setImportant(el, 'display', 'none');
    });
  };

  const styleAlert = () => {
    const root = document.querySelector('#MainContent[data-template="product"]');
    if (!root) return;

    let target = Array.from(root.querySelectorAll('button, a, [role="button"]')).find((el) => matchesAlert(cleanText(el)));
    if (!target) {
      target = Array.from(root.querySelectorAll('*')).find((el) => {
        const text = cleanText(el);
        return matchesAlert(text) && !Array.from(el.children).some((child) => matchesAlert(cleanText(child)));
      });
    }
    if (!target) return;

    replaceAlertTextNodes(target);
    target.classList.add('lunverk-price-alert');

    root.querySelectorAll('.lunverk-price-alert-wrap, .lunverk-price-alert-shell').forEach((el) => el.classList.remove('lunverk-price-alert-wrap', 'lunverk-price-alert-shell'));

    const ancestors = [];
    let current = target.parentElement;
    let depth = 0;
    while (current && current !== root && depth < 12) {
      const text = cleanText(current);
      if (matchesAlert(text) && text.length < 320) ancestors.push(current);
      current = current.parentElement;
      depth += 1;
    }

    const wrapper = [...ancestors].reverse().find((el) => el.querySelector('svg, img')) || ancestors[ancestors.length - 1] || target.parentElement;
    ancestors.forEach((el) => {
      if (el !== wrapper) { el.classList.add('lunverk-price-alert-shell'); flatten(el); }
    });

    const soldOut = !!root.querySelector('.product-form__submit[disabled], .product-form__submit[aria-disabled="true"]');
    const alertColor = '#233c2e';
    const alertWeight = soldOut ? '600' : '500';

    flatten(target);
    [['display','flex'],['align-items','center'],['flex','1 1 auto'],['width','auto'],['min-width','0'],['color',alertColor],['-webkit-text-fill-color',alertColor],['font-size','1.25rem'],['line-height','1.35'],['font-weight',alertWeight],['text-align','left'],['text-decoration','none'],['text-shadow','none'],['opacity','1'],['filter','none']].forEach(([p,v]) => setImportant(target,p,v));

    if (wrapper) {
      wrapper.classList.add('lunverk-price-alert-wrap');
      [['display','flex'],['align-items','center'],['gap','10px'],['width','100%'],['min-height','4.8rem'],['margin','1rem 0'],['padding','.8rem 1.2rem'],['background','#eef1eb'],['background-color','#eef1eb'],['border','1px solid rgba(35,60,46,.24)'],['border-radius','3px'],['box-shadow','none'],['outline','none'],['color',alertColor],['-webkit-text-fill-color',alertColor],['opacity','1'],['filter','none']].forEach(([p,v]) => setImportant(wrapper,p,v));

      wrapper.querySelectorAll('*').forEach((node) => {
        if (node.classList && node.classList.contains('lunverk-alert-icon')) return;
        setImportant(node, 'color', alertColor);
        setImportant(node, '-webkit-text-fill-color', alertColor);
        setImportant(node, 'opacity', '1');
        setImportant(node, 'filter', 'none');
        setImportant(node, 'text-shadow', 'none');
      });

      ensureBellIcon(wrapper, alertColor);
    }
  };

  const tidy = () => { ensureProductStyleOverrides(); styleAlert(); hideDuplicateTrust(); };
  const start = () => {
    tidy();
    if (!document.body) return;
    const observer = new MutationObserver(tidy);
    observer.observe(document.body, { childList: true, subtree: true });
    [250, 750, 1500, 3000].forEach((ms) => setTimeout(tidy, ms));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
